export const truncateToolMessages = (toolMessages: any) => {
    toolMessages.map((tool: any) => {
        if (
            (tool.message.truncatedContent === 'string' && tool.message.truncatedContent) ||
            (Array.isArray(tool.message.truncatedContent) && tool.message.truncatedContent.length > 0)
        ) {
            tool.message.content = tool.message.truncatedContent;
        }
    });
}

export const truncateHighlyDynamicToolMessages = (toolMessages: any) => {
    toolMessages.map((tool: any) => {
        if (
            (tool.message.tool_name === "editFile" || tool.message.tool_name === "createFile") &&
            (
                (tool.message.truncatedContent === 'string' && tool.message.truncatedContent) ||
                (Array.isArray(tool.message.truncatedContent) && tool.message.truncatedContent.length > 0)
            )
        ) {
            tool.message.content = tool.message.truncatedContent;
        }
    });
}

export const truncateOnRepeatToolMessages = (toolMessages: any, toolName: string) => {
    toolMessages.map((tool: any) => {
        if (
            (tool.message.tool_name === toolName) &&
            (
                (tool.message.truncatedContent === 'string' && tool.message.truncatedContent) ||
                (Array.isArray(tool.message.truncatedContent) && tool.message.truncatedContent.length > 0)
            )
        ) {
            tool.message.content = tool.message.truncatedContent;
        }
    });
}

export const truncateToolMessagesByFilePath = (toolMessages: any, filePath: string) => {
    toolMessages.forEach((tool: any) => {
        if (!tool.message.truncatedContent) return;

        // Check direct filePath field on tool message
        const toolFilePath = tool.message.filePath;

        // Check searchCodebase returned files
        const returnedFiles = tool.message.metadata?.returnedFileNames || [];

        const isDirectMatch = toolFilePath && (
            toolFilePath === filePath ||
            toolFilePath.endsWith(filePath) ||
            filePath.endsWith(toolFilePath)
        );

        const isInReturnedFiles = returnedFiles.some((rf: string) =>
            rf === filePath || rf.endsWith(filePath) || filePath.endsWith(rf)
        );

        if (isDirectMatch || isInReturnedFiles) {
            tool.message.content = tool.message.truncatedContent;
        }
    });
}

export const truncatePromptPrefix = (userMessage: any) => {
    if (!userMessage || !userMessage.message) return;

    if (userMessage.message.truncatedPromptPrefix !== null && userMessage.message.truncatedPromptPrefix !== undefined) {
        if (userMessage.message.truncatedPromptPrefix.trim() === "") {
            userMessage.message.promptPrefix = null;
        } else {
            userMessage.message.promptPrefix = userMessage.message.truncatedPromptPrefix;
        }
        userMessage.message.truncatedPromptPrefix = null;
    }
}

export const truncatePromptPostfix = (userMessage: any) => {
    if (!userMessage || !userMessage.message) return;

    if (userMessage.message.truncatedPromptPostfix !== null && userMessage.message.truncatedPromptPostfix !== undefined) {
        if (userMessage.message.truncatedPromptPostfix.trim() === "") {
            userMessage.message.promptPostfix = null;
        } else {
            userMessage.message.promptPostfix = userMessage.message.truncatedPromptPostfix;
        }
        userMessage.message.truncatedPromptPostfix = null;
    }
}

export const truncateUserMessage = (userMessage: any) => {
    truncatePromptPrefix(userMessage);
    truncatePromptPostfix(userMessage);
}